import { FC, useState, createContext, useEffect } from 'react';
import uesApiLogic from 'src/hooks/uesApiLogic';
import { usePgeApi } from '../API/usePgeApi';
import useToastContextLogic, {
  ToastContext
} from 'src/hooks/useToastContextLogic';
type Alert = {
  AlertId: number;
  AlertName: string;
  widgetTitle: string;
  preference: boolean;
  threshold: string;
};

type AlertContext = {
  alerts: Alert[];
  getAlert: (alertId: number) => Alert | undefined;
  updateAlertPreference: (alertId: number, preference: boolean) => void;
  getAlertInfoByWidget: (widgetTitle: string) => Alert | undefined;
} & ToastContext;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlertContext = createContext<AlertContext>({} as AlertContext);

export const AlertProvider: FC = ({ children }) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const { openToast, handleToast, toastMessage, setToastMessageValue } =
    useToastContextLogic();
  const { fetchAlertsInfo, updateAlerts } = usePgeApi();
  const { data: response } = uesApiLogic<Alert[]>({
    apiFunction: fetchAlertsInfo
  });
  useEffect(() => {
    setAlerts(
      response?.map((res) => ({
        AlertId: res.AlertId,
        AlertName: res.AlertName,
        preference: res.preference,
        widgetTitle: res.widgetTitle,
        threshold: res.threshold
      }))
    );
  }, [response]);
  const updateAlertPreference = async (alertId, preference) => {
    const alert = alerts.find((alert) => alert.AlertId === alertId);
    alert.preference = preference;
    const response = await updateAlerts({ AlertId: alert.AlertId, preference });
    handleToast(true);
    setToastMessageValue(response?.result as string);
    setAlerts(alerts);
  };

  const getAlert = (alertId) => {
    const alert = alerts?.find((alert) => alert.AlertId === alertId);
    return alert;
  };
  const getAlertInfoByWidget = (widgetTitle) => {
    const alert = alerts?.find((alert) => alert.widgetTitle === widgetTitle);
    return alert;
  };

  return (
    <AlertContext.Provider
      value={{
        alerts,
        updateAlertPreference,
        getAlertInfoByWidget,
        getAlert,
        openToast,
        handleToast,
        toastMessage,
        setToastMessageValue
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
